// Shared rules for the `twilio-agent-availability-changed` window event.
//
// The event has three producers: the agent's own toggle, the mount/reconnect/
// tab-visible refetch in AvailabilityToggle, and the server relay that
// home/index re-emits. Only the first is an act of intent, and only an act of
// intent may rebuild the Twilio Device — a refetch fires on every
// visibilitychange, so treating it as a shift start tore down and rebuilt the
// Device of every open tab, several thousand times a day per agent.

/** The agent flipped the switch themselves. */
export const AVAILABILITY_SOURCE_USER = 'user';
/** A read-back of the stored flag; carries no intent. */
export const AVAILABILITY_SOURCE_REFRESH = 'refresh';
/** The backend's ghost detector forced the agent offline (PROD-8664). */
export const AVAILABILITY_SOURCE_GHOST = 'ghost_detect';

/**
 * True when an availability event should rebuild this tab's Twilio Device.
 * The ghost-detect path is handled separately by the caller (it rebuilds on
 * an available:false event and bypasses the debounce), so this only answers
 * for the shift-start path.
 */
export const shouldReregisterOnAvailability = (detail) => {
  if (!detail) return false;
  if (detail.source !== AVAILABILITY_SOURCE_USER) return false;
  return detail.available === true;
};
